<template>
    <div>
        <el-dialog v-model="companionTeacherQuestionShow" :close-on-click-modal="false" :align-center="true"
            title="Tips" width="500" :show-close="false">
            <template #header>
                <div class="header">伴学师服务</div>
                <div class="close_icon cursor_pointer" @click="closePopup">
                    <el-icon :size="24">
                        <Close />
                    </el-icon>
                </div>
            </template>
            <div class="dialog_content">
                <el-image class="companion_teacher_question mt-20 ml-20 cursor_pointer"
                    :src="imgPath('companion_teacher_question.png')" @click="addQuestion"></el-image>
                <div class="ml-40 mt-10 cursor_pointer" @click="addQuestion">向老师提问</div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
export default {
    name: "GjkcH5CompanionTeacherQuestion",

    data() {
        return {
            companionTeacherQuestionShow: false,
        };
    },

    mounted() {

    },

    methods: {
        closePopup() {
            this.companionTeacherQuestionShow = false;
        },
        addQuestion(){
            this.closePopup();
            this.$emit('addQuestion');
        }
    },
};
</script>

<style lang="scss" scoped>
:deep(.el-dialog) {
    box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.06);
    border-radius: 20px 20px 10px 10px;
    padding: 0;
    width: 423px;
    height: 263px;
    position: relative;
}

:deep(.el-dialog__header) {
    position: relative;
}

.header {
    text-align: left;
    font-weight: bold;
    font-size: 20px;
    color: #111111;
    line-height: 60px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    padding-left: 20px;
}

.close_icon {
    position: absolute;
    top: 20px;
    right: 20px;
}

.dialog_content {
    font-size: 14px;
    color: #303030;

    .companion_teacher_question {
        width: 100px;
        height: 100px;
    }
}
</style>